export function hideBtns() {
    return {
        type: "HIDE_BTNS"
    }
}
export function showBtns() {
    return {
        type: "SHOW_BTNS"
    }
}

export function ShowBtnsReducer(show = false, action: any) {
    switch (action.type) {
        case "RELOAD":
            const isCentralBank = (action.payload.IsLoged ? action.payload.User.Options : action.payload.Options).IsCentralBank === 1;
            return !isCentralBank;
        case "SHOW_BTNS":
            return true
        case "HIDE_BTNS":
            return false
        default:
            return show
    }
}